export const FETCH_NOTIFICATIONS = 'scenes/VehicleDetail/Claim/Notifications/fetch_notifications'



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notifications/constants.js